<template>
  <v-card outlined>
    <v-card-text class="pb-0 pt-1">
      <v-row
        class="d-flex justify-space-between my-2"
        align="center"
        dense
        v-for="email in emails"
        :visible="emails.length > 0"
        :key="email.id"
      >
        <v-text-field
          v-model="email.input"
          outlined
          dense
          hide-details="auto"
          autocomplete="false"
          :clearable="true"
          :rules="[buildRequiredValidator(), buildEmailValidator()]"
          validate-on-blur
          :placeholder="$t('device.defectNotificationEmailPlaceholder')"
        />

        <v-btn
          icon
          :title="$t('actions.delete')"
          @click="removeEmail(email)"
        >
          <v-icon>mdi-minus-circle-outline</v-icon>
        </v-btn>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="addEmail" small :block="$vuetify.breakpoint.xs">
        <span>{{ $t('actions.add') }}</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/// DO NOT USE THIS FUCKING WTF COMPONENT FOR ANYTHING MORE THAN IT ALREADY IS

import {
  buildRequiredValidator,
  buildEmailValidator,
} from '@/utils/ValidatorBuilders';

export default {
  name: 'MultipleEmailsAdd',

  props: {
    value: {
      required: true,
      type: Array,
    },
  },

  computed: {
    emails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
  },

  methods: {
    buildRequiredValidator,
    buildEmailValidator,

    addEmail() {
      this.emails.push({ id: new Date().getTime(), input: null });
    },

    removeEmail(id) {

      this.$emit('removeEmail', id);
    },
  },
};
</script>

<style>
.email {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 400;
}
</style>
